import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Button, Chip, Paper, Stack, TextField, Typography } from "@mui/material";
import DiscountOverview from "../DiscountOverview/DiscountOverview";
import SelectedProductSummary from "./SelectedProductSummary/SelectedProductSummary";

const BarcodeInput = ({ label, dataKey, currentValues, setValue, disabled, onBlurEvent, table_data }) => {
	const updateBarcodes = (key, newBarcodes) => {
		setValue((prev) => ({
			...prev,
			product_selection: {
				...prev.product_selection,
				[key]: newBarcodes,
			},
		}));
	};
	const handlePaste = (e) => {
		e.preventDefault();
		const paste = e.clipboardData.getData("text");
		if (!paste) return;

		const newItems = paste
			.split(/[\n\r\s,]+/)
			.map((item) => item.trim())
			.filter((item) => item !== "");

		const uniqueNewItems = [...new Set(newItems)].filter((item) => !currentValues.includes(item));

		if (uniqueNewItems.length > 0) {
			updateBarcodes(dataKey, [...currentValues, ...uniqueNewItems]);
		}
	};

	return (
		<Box width={"100%"} display={"flex"} flexDirection={"column"}>
			<Typography color="#757575" gutterBottom>{label}</Typography>
			<Box sx={{
			border: "1px solid #c4c4c4",
			borderRadius: "4px",
			maxHeight: "120px",
			overflow: "hidden",
			p: 1,
			overflowY: "auto",
		}}>

			<Autocomplete
			// sx={{height: "120px"}}
			sx={{
				// height: "120px",
				"& .MuiAutocomplete-inputRoot": {
					display: "flex",
					flexWrap: "wrap",
					alignItems: "flex-start",
					gap: "4px",
					maxHeight: "100%",
					overflowY: "auto",
					overflowX: "hidden",
				},

				// Chips behave like inline blocks
				"& .MuiAutocomplete-tag": {
					flexShrink: 0,
					maxWidth: "100%",
				},

				// Input always goes to next line when needed
				"& .MuiAutocomplete-input": {
					flexGrow: 1,
					minWidth: "120px",
				},
			}}

				multiple
				freeSolo
				limitTags={2}
				getLimitTagsText={() => "..."}
				disabled={disabled}
				options={[]}
				value={currentValues}
				onChange={(event, newValue) => {
					updateBarcodes(dataKey, [...new Set(newValue)]);
				}}
				renderTags={(value, getTagProps) =>
					value.map((option, index) => <Chip variant="outlined" label={option} {...getTagProps({ index })} size="small" />)
				}
				renderInput={(params) => (
					<TextField
						{...params}
						variant="standard"
						placeholder="Enter or Paste barcodes"
						onPaste={handlePaste}
						disabled={disabled}
						onBlur={() => onBlurEvent()}
						InputProps={{
						...params.InputProps,
						disableUnderline: true,
					}}
					/>
				)}
			/>
			</Box>
		</Box>
	);
};

function ProductSelectionSection({
	value,
	setValue,
	disable,
	onBlurEvent,
	barcodeFile,
	setBarcodeFile,
	handleFileUpload,
	table_data,
	isCopyMode = false,
}) {

	const isUploadDisabled = disable || isCopyMode;

	const handleFileChange = (e) => {
		const newFile = e.target.files[0];
		const newFileName = `${newFile.name}`;
		const modifiedFile = new File([newFile], newFileName, { type: newFile.type });
		setBarcodeFile(modifiedFile);
		// Reset input so same file can be selected again
		e.target.value = null;
		setValue((prev) => ({
		...prev,
		product_selection: {
			...prev?.product_selection,
			discount_table: [],
			discount_barcode_table:[],
		},
	}));
	};

	return (
		<Box>
			<Box display="flex" gap={1} flexWrap="wrap" pl={2}>

				<Box display="flex" alignItems="center" gap={1} width="78%" sx={{border: "1px solid lightgray"}} padding="5px" borderRadius="4px">
					<Button
						variant="outlined"
						size="small"
						component="label"
						sx={{ height: 25, fontSize: "12px", textTransform: "none"}}
						disabled={isUploadDisabled}
					>
						Choose File
						<input
						type="file"
						id = "fileInput"
						hidden
						accept=".csv,text/csv"
						disabled={isUploadDisabled}
						onChange={(e) => handleFileChange(e)}
						/>
					</Button>

					<Typography variant="caption" width="200px" noWrap>
						{barcodeFile?.name || "No file chosen"}
					</Typography>
				</Box>
				<Button
					variant="contained" 
					onClick={handleFileUpload}
					disabled={isUploadDisabled}
					>
						Upload
				</Button>
				{/* <BarcodeInput
					label="Discount Barcodes"
					dataKey="discount_product"
					currentValues={value?.product_selection?.discount_product || []}
					setValue={setValue}
					disabled={disable}
					onBlurEvent={onBlurEvent}
				/> */}
				{/* <BarcodeInput
					label="NOD Barcodes"
					dataKey="nod"
					currentValues={value?.product_selection?.nod || []}
					setValue={setValue}
					disabled={disable}
				/> */}
			</Box>
			<Box pt={3}>
				<SelectedProductSummary
					data = {table_data}
				/>
			</Box>
		</Box>
	);
}

export default ProductSelectionSection;
